import React from 'react';

export const PartnerContext = React.createContext();
